import { fromJS } from 'immutable';
import LegalActions from '../actions/LegalActions';

const {
    GET_GUARDIAN_INFO,
    GET_GUARDIAN_INFO_SUCCESS,
    GET_GUARDIAN_INFO_FAILED,
    UPDATE_GUARDIAN_INFO,
    UPDATE_GUARDIAN_INFO_SUCCESS,
    UPDATE_GUARDIAN_INFO_FAILED
} = LegalActions.TYPES;

export const DEFAULT_STATE = fromJS({
    isLoading: false,
    isRqueiredCorrective: false,
    form: {
        guardianLastName: "",
        guardianEmail: "",
        guardianFirstName: "",
        guardianPhoneNumber: ""
    }
  });

  export default function(state = DEFAULT_STATE, action) {
    let newState = state;
    switch (action.type) {
        case GET_GUARDIAN_INFO: {
            newState = newState.updateIn(['isLoading'], () => true);
            return newState;
        }
            
        case GET_GUARDIAN_INFO_SUCCESS: {
            const { resp } = action.payload;
            newState = newState.updateIn(['isLoading'], () => false);
            newState = newState.updateIn(['form'], () => ({...resp}));
            return newState;
        }

        case GET_GUARDIAN_INFO_FAILED: {
            newState = newState.updateIn(['isLoading'], () => false);
            newState = newState.updateIn(['hasError'], () => true);
            return newState;
        }

        case UPDATE_GUARDIAN_INFO: {
            newState = newState.updateIn(['isLoading'], () => true);
            return newState;
        }
            
        case UPDATE_GUARDIAN_INFO_SUCCESS: {
            const { resp } = action.payload;
            newState = newState.updateIn(['isLoading'], () => false);
            newState = newState.updateIn(['form'], () => ({...resp}));
            return newState;
        }

        case UPDATE_GUARDIAN_INFO_FAILED: {
            newState = newState.updateIn(['isLoading'], () => false);
            newState = newState.updateIn(['hasError'], () => true);
            return newState;
        }

        default:
            return newState;
    }
  }
